import _defineProperty from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
/* eslint-disable consistent-return */

// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
import { eligibleProductOptionsForRestriction, isSpecialVersion3dot5 } from 'shared/helpers/specials-3-5';
import { getProductWeight } from 'shared/helpers/products';
import { getAvailableQuantity, isApplicableItem, mergeSatisfiers } from './common';
import { orderProductsForDiscountPrecedence } from '../utilities';
var formatConditionWeight = function formatConditionWeight(conditionWeight) {
  if (_.isNil(conditionWeight) || conditionWeight === 'Any Weight' || conditionWeight === 'N/A') {
    return 'any';
  }
  return getProductWeight(conditionWeight);
};
var isEligibleWeight = function isEligibleWeight(conditionWeight, conditionWeightOperator, item) {
  if (conditionWeight === 'any') {
    return true;
  }
  return conditionWeightOperator === 'greaterThan' ? item.weightInGrams > conditionWeight : item.weightInGrams === conditionWeight;
};
var Condition = /*#__PURE__*/function () {
  function Condition(condition, bogoCalcsData, bogoSpecial, items) {
    var _bogoSpecial$discount,
      _bogoSpecial$itemsFor,
      _this = this,
      _bogoSpecial$itemsFor2,
      _condition$quantity;
    _classCallCheck(this, Condition);
    this.bogoCalcsData = bogoCalcsData;
    this.bogoSpecial = bogoSpecial;
    this.condition = condition;
    this.discountToCartApplicable = !!((_bogoSpecial$discount = bogoSpecial.discountToCart) !== null && _bogoSpecial$discount !== void 0 && _bogoSpecial$discount.enabled);
    this.excludeDefeatedRewards = (_bogoSpecial$itemsFor = bogoSpecial.itemsForAPrice) !== null && _bogoSpecial$itemsFor !== void 0 ? _bogoSpecial$itemsFor : {
      enabled: false
    };
    this.previous = {
      satisfied: false,
      satisfiers: {}
    };
    this.satisfied = false;
    this.satisfiers = {};
    this.weight = formatConditionWeight(condition.weight);
    this.eligibleItems = orderProductsForDiscountPrecedence(_.filter(items, function (item) {
      var _bogoSpecial$totalWei;
      if (isSpecialVersion3dot5(bogoSpecial)) {
        var _eligibleProductOptio;
        return (((_eligibleProductOptio = eligibleProductOptionsForRestriction(item, condition, 'inclusion', bogoSpecial)) === null || _eligibleProductOptio === void 0 ? void 0 : _eligibleProductOptio.length) || 0) > 0;
      }
      var isApplicable = isApplicableItem(condition, item, bogoSpecial, 'condition');
      var meetsWeightRestrictions = !((_bogoSpecial$totalWei = bogoSpecial.totalWeight) !== null && _bogoSpecial$totalWei !== void 0 && _bogoSpecial$totalWei.enabled) ? isEligibleWeight(_this.weight, _this.condition.weightOperator, item) : true;
      return isApplicable && meetsWeightRestrictions;
    }), bogoSpecial, (_bogoSpecial$itemsFor2 = bogoSpecial.itemsForAPrice) !== null && _bogoSpecial$itemsFor2 !== void 0 && _bogoSpecial$itemsFor2.enabled ? 'rewards' : 'conditions');
    this.eligibleItemsHash = _.reduce(this.eligibleItems, function (acc, cur) {
      acc[cur.key] = cur;
      return acc;
    }, {});
    this.quantityRemaining = (_condition$quantity = condition === null || condition === void 0 ? void 0 : condition.quantity) !== null && _condition$quantity !== void 0 ? _condition$quantity : 0;
  }
  _createClass(Condition, [{
    key: "evaluateItem",
    value: function evaluateItem(_ref) {
      var item = _ref.item,
        pendingConditionsSatisfiers = _ref.pendingConditionsSatisfiers,
        pendingRewardsSatisfiers = _ref.pendingRewardsSatisfiers;
      var conditionId = this.condition._id;
      var isEligible = !!this.eligibleItemsHash[item.key];
      if (!isEligible) {
        return {
          satisfied: this.satisfied,
          satisfiers: this.satisfiers
        };
      }
      var availableQuantity = getAvailableQuantity({
        item: item,
        bogoCalcsData: this.bogoCalcsData,
        pendingConditionsSatisfiers: pendingConditionsSatisfiers,
        pendingRewardsSatisfiers: pendingRewardsSatisfiers,
        excludeDefeatedRewardsSatisfiers: this.excludeDefeatedRewards,
        discountToCartApplicable: this.discountToCartApplicable,
        specialId: this.bogoSpecial.specialId
      });
      if (availableQuantity > 0) {
        var quantityUsed = Math.min(availableQuantity, this.quantityRemaining);
        if (quantityUsed > 0) {
          this.satisfiers = mergeSatisfiers(this.satisfiers, _defineProperty({}, item.key, {
            conditions: _defineProperty({}, conditionId, {
              quantity: quantityUsed,
              specialId: this.bogoSpecial.specialId
            }),
            item: item,
            quantity: quantityUsed
          }));
        }
        this.quantityRemaining -= quantityUsed;
      }
      if (this.quantityRemaining < 1) {
        this.satisfied = true;
      }
      return {
        satisfied: this.satisfied,
        satisfiers: this.satisfiers
      };
    }
  }, {
    key: "revert",
    value: function revert() {
      var _this$condition$quant, _this$condition;
      var newPrevious = {
        satisfied: this.satisfied,
        satisfiers: this.satisfiers
      };
      this.satisfied = this.previous.satisfied;
      this.satisfiers = this.previous.satisfiers;
      this.previous = newPrevious;
      this.quantityRemaining = (_this$condition$quant = (_this$condition = this.condition) === null || _this$condition === void 0 ? void 0 : _this$condition.quantity) !== null && _this$condition$quant !== void 0 ? _this$condition$quant : 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this$condition$quant2, _this$condition2;
      var newPrevious = {
        satisfied: this.satisfied,
        satisfiers: this.satisfiers
      };
      this.satisfied = false;
      this.satisfiers = {};
      this.previous = newPrevious;
      this.quantityRemaining = (_this$condition$quant2 = (_this$condition2 = this.condition) === null || _this$condition2 === void 0 ? void 0 : _this$condition2.quantity) !== null && _this$condition$quant2 !== void 0 ? _this$condition$quant2 : 0;
    }
  }, {
    key: "setPrevious",
    value: function setPrevious() {
      this.previous = {
        satisfied: this.satisfied,
        satisfiers: this.satisfiers
      };
    }
  }, {
    key: "removeSatisfiers",
    value: function removeSatisfiers(satisfiedCondition) {
      var _this2 = this;
      // if we have started assigning satisfiers to conditions that weren't fully satisfied,
      // but then used some of those items to fully satisfy ANOTHER condition, then
      // we want to clean out those half applied ones
      var keys = _.keys(satisfiedCondition.satisfiers);
      var unusedSatisfiers = _.keys(this.satisfiers);
      _.forEach(keys, function (key) {
        if (_.includes(unusedSatisfiers, key)) {
          _this2.quantityRemaining += satisfiedCondition.satisfiers[key].quantity;
          _this2.satisfiers[key].quantity -= satisfiedCondition.satisfiers[key].quantity;
          if (_this2.satisfiers[key].quantity === 0) {
            delete _this2.satisfiers[key];
          }
        }
      });
    }
  }]);
  return Condition;
}();
export default Condition;